export const gallery = {
  productTypes: {
    filterBags: 'Sacs Filtrants',
    filterCartridges: 'Cartouches Filtrantes',
    filterBagHousings: 'Boîtiers à Sacs Filtrants',
    filterCartridgeHousings: 'Boîtiers à Cartouches Filtrantes',
    filterSheets: 'Plaques Filtrantes',
    filterPress: 'Filtre-Presse',
    filtrationEquipment: 'Équipements & Systèmes de Filtration',
    filterAids: 'Adjuvants de Filtration',
    beerFiltration: 'Filtres pour Bière',
    microbiologicalMedia: 'Milieux Microbiologiques',
    other: 'Autre',
  },
  hero: {
    title: 'Galerie de Produits',
    subtitle: 'Explorez notre gamme complète de produits de filtration industrielle et de solutions de nos partenaires technologiques de renommée mondiale',
  },
  filters: {
    allPartners: 'Tous les Partenaires',
    allProductTypes: 'Tous les Types de Produits',
    searchPlaceholder: 'Rechercher des produits, catégories, spécifications...',
    clear: 'Effacer',
    resultsFound: 'produit trouvé',
    resultsFoundPlural: 'produits trouvés',
  },
  noResults: {
    title: 'Aucun produit trouvé',
    description: 'Essayez d\'ajuster votre recherche ou vos filtres pour trouver ce que vous cherchez.',
    clearFilters: 'Effacer les Filtres',
  },
  cta: {
    title: 'Besoin d\'Aide pour Choisir le Bon Produit ?',
    subtitle: 'Nos experts techniques sont prêts à vous aider à sélectionner la solution de filtration parfaite pour votre application spécifique',
    contactExperts: 'Contactez Nos Experts',
    requestStudy: 'Demander une Étude',
  },
};